import classes from "./ActiveDot.module.css";

export default function ActiveDot({isActive}) {
    return (
        <div className={`${classes.dot} ${isActive ? classes.active : classes.inactive}`}/>
    )
}